import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { SharedService } from 'src/app/services/shared/shared.service';

@Component({
  selector: 'app-addon',
  templateUrl: './addon.component.html',
  styleUrls: ['./addon.component.scss']
})
export class AddonComponent implements OnInit, OnDestroy {
  public isAddonOpen: boolean = false;
  public vinInfo: Object = {};
  public subscriptions: Subscription[] = [];
  public currentLang = 'en';
  constructor(
    public sharedService: SharedService,
    public router: Router,
    public locale: LocaleService
  ) {
    this.getVinInfo();
  }

  ngOnInit(): void {
    this.locale.localeSubject.subscribe((lang) => {
      if(lang) {
        this.currentLang = lang;
      }else {
        this.setLocale('en')
      }
    })
    // this.closeOnRouteChange();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  getVinInfo() {
    const infoSub = this.sharedService.vinInformation.subscribe((res) => {
      if (res) {
        this.vinInfo = res;
      }
    });
    this.subscriptions.push(infoSub);
  }

  addOnToggle() {
    this.isAddonOpen = !this.isAddonOpen;
  }

  closeOnRouteChange() {
    this.router.events.subscribe((res) => { 
      if (res instanceof NavigationEnd) this.isAddonOpen = false; 
    });
  }

  setLocale(lang: string) {
    if (lang === 'en') this.locale.langSetter = lang;
    else if (lang === 'ar') this.locale.langSetter = lang;
  }
}
